import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import { isResource } from 'src/containers/ProjectDiagram/utils/data';

export const getPreviousResource = (diagram: DiagramSnapshot, key: string) => {
  const found = diagram.model.modelData.draftData?.prevNodeDataMap[key];
  return found && isResource(found) ? found : null;
};
